import EventEmitter from './EventEmitter.js'

/**
 * Time
 * Drives the render loop via requestAnimationFrame.
 * Tracks elapsed time and per-frame delta.
 * Triggers 'tick' every frame — Experience listens to propagate updates.
 */
export default class Time extends EventEmitter {
    constructor() {
        super()

        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16
        this._rafId = null

        this._rafId = window.requestAnimationFrame(() => this.tick())

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) return
            // Reset current so delta doesn't spike after a long hidden period.
            this.current = Date.now()
            if (!this._rafId) this._rafId = window.requestAnimationFrame(() => this.tick())
        })
    }

    tick() {
        this._rafId = null

        if (document.hidden) return

        const currentTime = Date.now()
        this.delta = currentTime - this.current
        this.current = currentTime
        this.elapsed = this.current - this.start

        this.trigger('tick')

        this._rafId = window.requestAnimationFrame(() => this.tick())
    }
}
